<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2" ref="statisTitle">
            <span>教师课堂行为分析</span>
            <Tooltip max-width="250" placement="right"  content="统计教师对于板书（白板和智能板）、课本、课件、讲评和互动这几大侧边栏工具的使用数据">
                <img :src="require(`@/assets/images/tip_2.png`)"/>
            </Tooltip>
        </div>
        <div class="content" :style="contentStyleObj">
            <div
                    id="classroom-behavior"
                    style="width: 100%; height: 100%; position: absolute"
            ></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "teaClassroomBehavior",
        data() {
            return {
                boxWrapStyleObj: {
                    height: "",
                },
                contentStyleObj: {
                    height: "",
                },
            };
        },
        props: {
            teaClassBehavior: Array,
            screenHeight: Number,
            titleHeight: Number,
        },
        watch: {
            teaClassBehavior(value) {
                if (value) {
                    this.initChart();
                }
            },
            screenHeight: "initBoxHeight",
            titleHeight: "initBoxHeight",
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight() {
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }

                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight =
                    boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
                this.boxWrapStyleObj.height = boxWrapHeight + "px";
                this.contentStyleObj.height = contentHeight + "px";
            },
            /**
             * 初始化教师课堂行为柱状图
             */
            initChart() {
                this.teaClassBehavior.forEach((item) => {
                    item.name = item.type;
                    item.value = item.count;
                });
                const option = {
                    tooltip: {
                        trigger: "item",
                    },
                    color: ['#0271BD', '#A682E6', '#E15D68', '#F29961', '#00CCCD'],
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: ['40%', '70%'],
                            data: this.teaClassBehavior,
                            roseType: 'radius',
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            }
                        }
                    ]
                };
                let dataChart = this.$echarts.init(
                    document.getElementById("classroom-behavior")
                );
                dataChart.setOption(option);
                window.addEventListener("resize", function () {
                    dataChart.resize();
                });
            },
        },
        mounted() {
            this.$nextTick(() => {
            });
        },
    };
</script>
<style lang="scss" scoped>
    @import "../../../style/databoard";

    .bg2 {
        background-image: url("../../../assets/images/databoard/title-bg2.png");
    }

    .statis-title {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 14px;
            height: 14px;
            margin-left: 5px;
            margin-top: -4px;
            cursor: pointer;
        }
        .tip-box{
            position: absolute;
            right: -60px;
            z-index: 9999;
            width: 180px;
            padding: 10px 6px;
            text-align: left;
            border: 1px solid rgba(14, 249, 250, 0.6);
            border-radius: 6px;
            color: #fff;
        }
    }
</style>
